export const CREATE_DIMENSIONING = '/dimensioning'
